import React from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SecurityIcon } from '~/img';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.grey[600],
    width: '14em',
    height: '14em',
  },
  h1: {
    color: theme.palette.grey[600],
    fontWeight: 900,
  },
  description: {
    color: theme.palette.grey[600],
  },
}));

const TenantLicensePaywall = () => {
  const translate = useTranslate();
  const t = (key: string): string => translate(`components.ra.fields.Paywall.${key}`);
  const classes = useStyles();
  return (
    <Grid container spacing={3} justify='center' alignItems='center' direction='column'>
      <Grid item>
        <SecurityIcon className={classes.icon} />
      </Grid>
      <Grid item>
        <Typography variant='h1' className={classes.h1}>
          {t('title')}
        </Typography>
      </Grid>
      <Grid item className={classes.description}>
        {t('descriptionLine1')}
      </Grid>
      <Grid item className={classes.description}>
        {t('descriptionLine2')}
      </Grid>
    </Grid>
  );
};

export default TenantLicensePaywall;
